// product-storage.service.ts
import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProductStorageService {
  constructor(private dbService: NgxIndexedDBService) {}

  async saveLocalProduct(product: any): Promise<any> {
    return await firstValueFrom(this.dbService.add('failedProducts', { data: product }));
  }

  getAllLocalProducts(): Observable<any[]> {
    return this.dbService.getAll('failedProducts');
  }

  async deleteLocalProduct(id: number): Promise<any> {
    return await firstValueFrom(this.dbService.delete('failedProducts', id));
  }

  async clearAll(): Promise<any> {
    return await firstValueFrom(this.dbService.clear('failedProducts'));
  }
}
